import { Coordinate } from 'modules/types/common';
import { defaultCoordinates, sortOptions } from './constants';

export function orFallbackArray<T>(array?: T[], fallback: T[] = []): T[] {
  return Array.isArray(array) && array.length ? array : fallback;
}

export function orFallbackCoords(coords?: Coordinate, fallback: Coordinate = defaultCoordinates) {
  return coords?.latitude && coords?.longitude ? coords : fallback;
}

export function createSortOptions(acceptedTC: boolean) {
  const key = acceptedTC ? 'ACCEPTED_TC' : 'DECLINED_TC';
  return sortOptions[key];
}

export const parseDistance = (distance?: string) => {
  if (!distance) return null;

  const [number, unit] = distance.split(' ');
  const floatNum = parseFloat(number);
  const distanceParsed = floatNum.toFixed(1);
  let returnDistance = distanceParsed;
  if (floatNum > 5) {
    returnDistance = Math.round(floatNum).toString();
  }
  return ` \u2014 ${returnDistance} ${unit}.`;
};
